import React from "react";

const SetItemsContext = React.createContext({
    data: null,
    defaultService: null,
    isLoading: false,
    step: 0,
    showAddon: false,
    addonIsActive: false,
    addonServiceList: [],
    postServiceList: [],
    selectedType: "post",
    selectedServices: [],
    requiredServices: [],
    optionalServices: [],
    price: null,
    handleChangeSelectedServices: () => {
    },
    handleShowOption: () => {

    },
    options: null,
    handleSelectedType: () => {

    },
    handleStep: () => {

    },
    handleConfirm:()=>{

    },
    handleGetItems:()=>{

    }

});
export default SetItemsContext;